import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import usePush from 'hooks/router/usePush';
import { hide } from 'state/modules/popup';
import { Divider, Header, Label, Portal, Segment, Transition } from 'components/HeroSemantic';

const baseStyle = {
  top: '1%',
  left: '50%',
  position: 'fixed',
  transform: 'translateX(-50%)',
  textAlign: 'center',
  minWidth: '300px',
  zIndex: 1000,
};
const subheaderStyle = {
  padding: '5px',
  color: 'var(--owner-text-muted)',
};
const buttonStyle = {
  color: 'var(--tenant-primary)',
  border: 'none',
  fontSize: '13px',
};
const closeButtonStyle = {
  color: 'var(--owner-text-muted)',
  border: 'none',
  fontSize: '13px',
};

const Popup = () => {
  const popup = useSelector(state => state.popup);
  const dispatch = useDispatch();
  const { push } = usePush();

  const { isOpen, title, text, actionText, actionLink, headerColor, showActionButton } = popup;

  const handleClick = link => {
    push(link);
    dispatch(hide());
  };

  const headerStyle = {
    padding: '10px 5px 0px',
    color: headerColor || '#005486',
  };

  return (
    <Transition visible={isOpen} animation="fade" duration={2000}>
      <Portal open={isOpen}>
        <Segment style={baseStyle}>
          <Header style={headerStyle}>
            {title}
            <Header.Subheader style={subheaderStyle}>{text}</Header.Subheader>
          </Header>
          <Divider />
          {
            showActionButton && (
              <Label as="a" basic style={buttonStyle} onClick={() => handleClick(actionLink)}>
                {actionText}
              </Label>
            )
          }
          <Label as="a" basic style={closeButtonStyle} onClick={() => dispatch(hide())}>
            <FormattedMessage id="general.close" />
          </Label>
        </Segment>
      </Portal>
    </Transition>
  );
};

export default Popup;
